var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c("v-card-title", [_vm._v("Options")]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "Select option",
                      dense: "",
                      outlined: "",
                      items: _vm.options,
                    },
                    model: {
                      value: _vm.selectedOption,
                      callback: function ($$v) {
                        _vm.selectedOption = $$v
                      },
                      expression: "selectedOption",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Input 1", dense: "", outlined: "" },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Input 2", dense: "", outlined: "" },
                  }),
                  _vm._v(" "),
                  _c("v-btn", { attrs: { block: "", color: "primary" } }, [
                    _vm._v("Load Section"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c("v-text-field", {
                attrs: { label: "XML ID(s)", outlined: "", dense: "" },
                model: {
                  value: _vm.xmlIdsInput,
                  callback: function ($$v) {
                    _vm.xmlIdsInput = $$v
                  },
                  expression: "xmlIdsInput",
                },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.isLoading },
                  on: { click: _vm.loadSection },
                },
                [_vm._v("\n                Load Section\n            ")]
              ),
              _vm._v(" "),
              _c("default-content-section-controller", {
                attrs: { xmlIdsQuery: _vm.xmlIds },
                on: { loading: _vm.setLoading },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }